/*============================================================================
  Size table
==============================================================================*/
if (!customElements.get('size-table')) {
  customElements.define(
    "size-table",
    class SizeTable extends HTMLElement {
      constructor() {
        super();
        this.itemsData = [];
        this.basePrice = tierData.base_price;
        this.pricingTier = [];
        this.submitButton = this.querySelector("#bulk-add-to-cart");
        this.totalQty = this.querySelector(".total-variant-qty");
        this.subTotal = this.querySelector(".subtotal-variant-price");
      }

      connectedCallback() {
        this.handleXLRows();
        this.loadTierData();
        this.initializeEventListeners();
      }

      initializeEventListeners() {
        this.submitButton.addEventListener("click", this.addToCart.bind(this));

        this.querySelectorAll("input.variant-qty").forEach((input) => {
          input.addEventListener("change", () => {
            this.validateQuantity(input);
            this.updateTotal();
          });
          input.addEventListener("input", () => {
            this.validateQuantity(input);
            this.updateTotal();
          });
        });

        this.querySelectorAll(".refresh-variant-data").forEach((button) => {
          button.addEventListener("click", () => {
            this.resetQuantities();
          });
        });
      }

      loadTierData() {
        fetch(window.hulkapps.vd_url + '/api/v2/shop/get_offer_table', {
          method: 'POST',
          body: JSON.stringify(tierData),
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => response.json())
        .then((data) => {
          const pricingData = data.eligible_offer.offer_levels.replaceAll('[[', '').replaceAll(']]', '').split('],[');
          this.pricingTier = pricingData.map((value) => value.replaceAll('"', '').split(','));
          console.log(this.pricingTier);
        })
        .catch((error) => {
          console.error(error);
        });

        
        // this.pricingTier = [
        //   ["2", "5", "percent_discount", "", "0"],
        //   ["20", "10", "percent_discount", "", "0"],
        //   ["100", "20", "percent_discount", "", "0"],
        //   ["300", "30", "percent_discount", "", "0"],
        //   ["500", "40", "percent_discount", "", "0"],
        // ];
      }

      handleXLRows() {
        const xlRows = this.querySelectorAll(".xl-row");

        xlRows.forEach((row) => {
          const previousRow = row.previousElementSibling;
          const xlQtyCell = row.querySelector(".xl-qty");

          let currentSize = row.querySelector(".size").textContent.replace("XL", "").trim();

          if (previousRow && previousRow.querySelector(".size") && previousRow.querySelector(".size").textContent.replace("XL", "").trim() === currentSize) {
            let fullfitQtyCell = previousRow.querySelector(".xl-qty");
            fullfitQtyCell.innerHTML = xlQtyCell.innerHTML;
            row.style.display = "none";
          }
        });
      }

      addToCart() {
        this.itemsData = [];
        this.querySelectorAll("input.variant-qty").forEach((input) => {
          if (input.value > 0) {
            this.itemsData.push({
              quantity: input.value,
              id: input.dataset.variant,
            });
          }
        });

        if (this.itemsData.length > 0) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: this.itemsData }),
          })
            .then((response) => response.json())
            .then(() => {
              //SS events
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.submitButton.removeAttribute("aria-disabled");
              this.submitButton.querySelector(".loading-overlay__spinner").classList.add("hidden");
              this.submitButton.classList.remove("loading");
            });
        } else {
          this.querySelector(".atc-qty-error").style.display = "block";
          setTimeout(() => {
            this.querySelector(".atc-qty-error").style.display = "none";
          }, 5000);
        }
      }

      getPrice(quantity) {
        const qty = parseInt(quantity, 10);
        return this.pricingTier
          ? this.pricingTier.reduce((unitPrice, [threshold, discount]) => {
              return qty >= parseInt(threshold, 10) ? discount : unitPrice;
            }, 0)
          : 0;
      }

      validateQuantity(input) {
        const min = parseInt(input.min, 10);
        const max = parseInt(input.max, 10);
        let value = parseInt(input.value, 10);

        if (value < min) {
          input.value = min;
        } else if (value > max) {
          input.value = max;
        }
      }

      updateTotal() {
        let totalQty = 0;
        let totalPrice = 0.0;

        this.querySelectorAll("input.variant-qty").forEach((input) => {
          const currentQty = parseInt(input.value, 10);
          if (currentQty > 0) {
            const percentDiscount = this.getPrice(currentQty);
            const discount = (percentDiscount / 100) * this.basePrice;
            const finalPrice = this.basePrice - discount;

            totalQty += currentQty;
            totalPrice += currentQty * finalPrice;
          }
        });

        this.totalQty.textContent = totalQty;
        this.subTotal.textContent = totalPrice.toFixed(2);
      }

      resetQuantities() {
        this.querySelectorAll(".variants-data-wrap input.variant-qty").forEach((input) => {
          input.value = 0;
        });
        this.totalQty.textContent = 0;
        this.subTotal.textContent = "0.00";
      }
    }
  );
}
